"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NON_NUMERIC_REGEX = void 0;
/**
 * @constant
 * @type {RegExp}
 * @description Regex para identificar caracteres não numéricos.
 */
exports.NON_NUMERIC_REGEX = /\D/g;
